/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { IFormFile } from '../iFormFile.schema';

export const UploadFileDailyActivityMonitoringLogHeadersBody = zod.object({
  "file": zod.lazy(() => IFormFile).optional()
})

export type UploadFileDailyActivityMonitoringLogHeadersBody = zod.input<typeof UploadFileDailyActivityMonitoringLogHeadersBody>;
export type UploadFileDailyActivityMonitoringLogHeadersBodyOutput = zod.output<typeof UploadFileDailyActivityMonitoringLogHeadersBody>;
